import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);


  const handleMenuClick = (e) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    const scrollToMenu = () => {
      const menuElement = document.getElementById('menu');
      if (menuElement) {
        menuElement.scrollIntoView({ behavior: 'smooth' });
      } else {
        setTimeout(scrollToMenu, 50);
      }
    };
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(scrollToMenu, 400);
    } else {
      scrollToMenu();
    }
  };

  return (
    <header className={`fixed top-0 left-0 w-full z-[100] transition-all duration-300 ${
      isScrolled
        ? 'bg-black/90 backdrop-blur-md py-3 border-b border-white/10 shadow-2xl' 
        : 'bg-transparent py-6 border-b border-transparent'
    }`}>

      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        
        {/* LOGO SECTION */}
        <Link to="/" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})} className="flex items-center gap-4 group">
          <div className="relative">
            {/* The Actual Logo Image */}
            <img 
              src="/logo.jpg" 
              alt="Prime Eats Logo" 
              className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover border-2 border-[#d4af37] transition-transform duration-300 group-hover:scale-110 shadow-[0_0_15px_rgba(212,175,55,0.3)]"
            />
            {/* Decorative Gold Bar next to logo */}
            <div className="absolute -right-2 top-1/2 -translate-y-1/2 w-1 h-8 bg-[#d4af37] hidden md:block"></div>
          </div>
          
          <h1 className="font-['Bebas_Neue'] text-2xl md:text-3xl text-white tracking-[0.15em] leading-none">
            PRIME <span className="text-[#d4af37]">EATS</span>
          </h1>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-10">

          <Link 
            to="/" 
            onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
            className={`font-['Bebas_Neue'] text-xl tracking-widest transition-all hover:text-[#d4af37] ${location.pathname === '/' ? 'text-[#d4af37]' : 'text-gray-300'}`}
          >
            HOME
          </Link>

          <a href="#menu" onClick={handleMenuClick} className="font-['Bebas_Neue'] text-xl tracking-widest text-gray-300 hover:text-[#d4af37] transition-all">
            MENU
          </a>

          <Link 
            to="/about" 
            className={`font-['Bebas_Neue'] text-xl tracking-widest transition-all hover:text-[#d4af37] ${location.pathname === '/about' ? 'text-[#d4af37]' : 'text-gray-300'}`}
          >
            ABOUT US
          </Link>

        <a href="tel:+17342864221" className="bg-[#d4af37] text-black font-['Bebas_Neue'] text-xl px-8 py-2.5 rounded-sm hover:bg-white transition-all transform hover:-translate-y-0.5 active:translate-y-0 shadow-lg">
            ORDER NOW
          </a>
        </nav>

        {/* Mobile Toggle (Animated 3 Lines) */}
        <button 
          className="md:hidden flex flex-col gap-1.5 z-[120] p-2" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle Menu"
        >

          <div className={`w-8 h-0.5 bg-white transition-all duration-300 ${mobileMenuOpen ? 'rotate-45 translate-y-2 bg-[#d4af37]' : ''}`}></div>
          <div className={`w-8 h-0.5 bg-white transition-all duration-300 ${mobileMenuOpen ? 'opacity-0' : ''}`}></div>
          <div className={`w-8 h-0.5 bg-white transition-all duration-300 ${mobileMenuOpen ? '-rotate-45 -translate-y-2 bg-[#d4af37]' : ''}`}></div>
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      <div className={`lg:hidden fixed top-20 right-4 w-64 bg-black/95 backdrop-blur-xl border border-white/20 rounded-xl shadow-2xl z-[120] flex flex-col p-6 gap-6 transition-all duration-300 ease-in-out ${
        mobileMenuOpen ? 'translate-x-0 opacity-100 visible' : '-translate-x-full opacity-0 invisible'
      }`}>
        <Link to="/" onClick={() => { setMobileMenuOpen(false); window.scrollTo({top: 0, behavior: 'smooth'}); }} className={`py-2 border-b border-white/10 text-2xl font-['Bebas_Neue'] transition-all ${location.pathname === '/' ? 'text-[#d4af37]' : 'text-white hover:text-[#d4af37]'}`}>HOME</Link>
        <a href="#menu" onClick={handleMenuClick} className="text-2xl font-['Bebas_Neue'] text-white hover:text-[#d4af37] py-2 border-b border-white/10">MENU</a>
        <Link to="/about" onClick={() => setMobileMenuOpen(false)} className={`py-2 border-b border-white/10 text-2xl font-['Bebas_Neue'] transition-all ${location.pathname === '/about' ? 'text-[#d4af37]' : 'text-white hover:text-[#d4af37]'}`}>ABOUT US</Link>
        <a href="tel:+17342864221" className="mt-2 bg-[#d4af37] text-black px-6 py-3 font-['Bebas_Neue'] text-xl rounded-lg shadow-lg hover:bg-white transition-all">ORDER NOW</a>
      </div>
    </header>
  );
}

export default Header;

